module.exports = __webpack_public_path__ + "static/media/sn.01fc886a.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sn.svg
// module id = 2211
// module chunks = 0